import script from "./ColoringPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ColoringPage.vue?vue&type=script&setup=true&lang=js"

import "./ColoringPage.vue?vue&type=style&index=0&id=b7b270b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7b270b2"]])

export default __exports__